import { useEffect, useState } from 'react'

export function useScreenSize() {
	//Responsiveness
	const [screenSize, setScreenSize] = useState('')

	useEffect(() => {

		function getScreenSize(w: number) {

			if (w > 1200) {
				return 'desktop'

			} else if (w > 950) {
				return 'tablet'
			}
			else {
				return 'mobile'
			}

		}

		const listener = () => {
			setScreenSize(getScreenSize(window.innerWidth))
		}

		window.addEventListener('resize', listener)
		listener()

		return () => window.removeEventListener('resize', listener)
	}, [])

	return { screenSize }
}
